(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stormcrew-shipping-country"] && !Shopify.designMode) return;
  try {
    (() => {
    const formSelector = '.stormcrew-free-shipping__destination';
    const selector = `${formSelector} select[name="country_code"]`;
    let pending = false;

    document.addEventListener('change', (event) => {
      if (event.target?.matches?.(selector)) event.target.form.requestSubmit();
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!form?.matches?.(formSelector)) return;
      event.preventDefault();
      if (pending) return;
      const cart = form.closest('cart-items-component');
      const notice = form.closest('.stormcrew-free-shipping');
      if (!cart || !notice) return;
      const country = form.elements.country_code.value;
      const body = new FormData(form);
      const returnTo = new URL(window.location.href);
      returnTo.searchParams.delete('sections');
      returnTo.searchParams.set('section_id', cart.dataset.sectionId);
      body.set('return_to', returnTo.pathname + returnTo.search);
      pending = true;
      cart.inert = true;
      cart.setAttribute('aria-busy', 'true');
      notice.querySelector('.stormcrew-free-shipping__message').textContent = notice.dataset.updating;
      notice.querySelector('[data-shipping-retry]').hidden = true;
      const progress = notice.querySelector('progress');
      if (progress) progress.style.visibility = 'hidden';

      try {
        const { morph, MORPH_OPTIONS } = await import('@theme/morph');
        const response = await fetch(form.action, {
          method: 'POST',
          body,
          credentials: 'same-origin',
          cache: 'no-store',
          signal: AbortSignal.timeout(15000),
        });
        if (!response.ok) throw new Error('Localization request failed');
        const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextCart = fragment.getElementById(`shopify-section-${cart.dataset.sectionId}`)?.querySelector('cart-items-component');
        if (nextCart?.querySelector('.stormcrew-free-shipping')?.dataset.shippingCountry !== country) {
          throw new Error('Localization response did not match the selected country');
        }
        morph(cart, nextCart, MORPH_OPTIONS);
        try {
          window.bucksCC?.reConvert?.();
        } catch {
          // The server-rendered USD amount remains a valid fallback.
        }
      } catch {
        notice.querySelector('.stormcrew-free-shipping__message').textContent = notice.dataset.error;
        notice.querySelector('[data-shipping-retry]').hidden = false;
        if (progress) progress.hidden = true;
      } finally {
        pending = false;
        cart.inert = false;
        cart.removeAttribute('aria-busy');
        const drawer = cart.closest('cart-drawer-component');
        if (!drawer || drawer.querySelector('dialog')?.open) {
          const control = cart.querySelector(`${formSelector} sc-select`) || cart.querySelector(selector);
          control?.focus({ preventScroll: true });
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
